import { Button, Tooltip } from 'antd'
import React, { useState } from 'react'
import { Withdrawal } from 'src/core/models'
import { CustomModal } from 'src/components'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import WithdrawalDetails from './WithdrawalDetails/WithdrawalDetails'

const WithdrawalDetailsButton: React.FC<{ withdrawal: Withdrawal }> = ({ withdrawal }) => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  const cardTitle: string = {
    paypal: t('Withdrawals.PaypalTitle'),
    bank: t('Withdrawals.BankTitle')
  }[withdrawal.kind]

  return <>
    <Tooltip title={t('Withdrawals.Details')} color={'blue'}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        className={`radius-100`}
        onClick={() => setIsModalVisible(true)}
        icon={<EyeOutlined />}
      />
    </Tooltip>

    <CustomModal
      width={650}
      footer={null}
      open={isModalVisible}
      title={cardTitle}
      onCancel={() => setIsModalVisible(false)}
    >
      <WithdrawalDetails withdrawal={withdrawal} />
    </CustomModal>
  </>
}

export default WithdrawalDetailsButton
